import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { PhotoStatus } from "./PhotoPrepare";

interface PhotoPrepareCompactProps {
  photoStatuses: PhotoStatus[];
  onUpload: () => void;
  isUploading?: boolean;
}

export const PhotoPrepareCompact = ({ photoStatuses, onUpload, isUploading = false }: PhotoPrepareCompactProps) => {
  const { toast } = useToast();

  const pendingCount = photoStatuses.filter(p => p.status === 'pending').length;
  const processingCount = photoStatuses.filter(p => p.status === 'processing').length;
  const readyCount = photoStatuses.filter(p => p.status === 'ready').length;

  const handleUpload = async () => {
    // Sempre permitir upload, independente do status
    await onUpload();
  };

  return (
    <div className="flex items-center space-x-4">
      {/* Status Indicators */}
      <div className="flex items-center space-x-3">
        {pendingCount > 0 && (
          <div className="flex items-center space-x-1">
            <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse"></div>
            <span className="text-xs font-medium text-yellow-400">{pendingCount}</span>
            <span className="text-xs text-muted-foreground">Pend</span>
          </div>
        )}
        {processingCount > 0 && (
          <div className="flex items-center space-x-1">
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
            <span className="text-xs font-medium text-blue-400">{processingCount}</span>
            <span className="text-xs text-muted-foreground">Proc</span>
          </div>
        )}
        {readyCount > 0 && (
          <div className="flex items-center space-x-1">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            <span className="text-xs font-medium text-green-400">{readyCount}</span>
            <span className="text-xs text-muted-foreground">Prontas</span>
          </div>
        )}
      </div>

      {/* Upload Button - Sempre disponível */}
      <Button
        onClick={handleUpload}
        disabled={isUploading}
        size="sm"
        className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 shadow-lg shadow-purple-500/25 border-0 text-white"
      >
        {isUploading ? (
          <>
            <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white mr-2"></div>
            Enviando...
          </>
        ) : (
          <>
            <Send className="h-3 w-3 mr-2" />
            Enviar Todas ({photoStatuses.length})
          </>
        )}
      </Button>
    </div>
  );
};
